import Vue from "vue";
import QRious from "qrious";

export default {
  printWorkOrder(solicitud) {
    console.log("----->>>>>>>>>",solicitud)
    let itemsProducts = ``;
    let logo_ticket = "";
    // ! solicitud de analisis pdf
    if (solicitud.company_img_url) {
      logo_ticket = `<img class="imgCenter" src='/img/${solicitud.company_img_url}' height="70" width="260" />`;
    }

    let company_phone = "";
    if (solicitud.company_phone) {
      company_phone = `<span>${solicitud.company_phone}</span><br>`;
    }

    //let type_document = 'FACTURA ELECTRÓNICA';
    //if (solicitud.sales_document === 'BOLETA') {
    let type_document = "ORDEN DE TRABAJO";
    //} else if (solicitud.sales_document === 'TICKET') {
    //type_document = 'TICKET DE VENTA';
    //}

    let customer_address = "";
    if (solicitud.customer_address) {
      customer_address = solicitud.customer_address.toUpperCase();
    }

    let customer_born_date = "";
    if (solicitud.customer_born_date) {
      customer_born_date = solicitud.customer_born_date.toUpperCase();
    }

    let customer_gender = "";
    if (solicitud.gender) {
      customer_gender = solicitud.gender.toUpperCase();
    }

    let paymentMethod = "";
    if (solicitud.payment_method) {
      paymentMethod = solicitud.payment_method;
    }

    let doctorName = "";
    if (solicitud.doctor_name) {
      doctorName = solicitud.doctor_name.toUpperCase();
    }

    let payWith = "";
    if (paymentMethod == "EFECTIVO") {
      if (solicitud.pay_with > 0) {
        payWith = `
              <tr>
                <td style="width: 70%; text-align: left;">
                    <span class="voucher-label"><b>PAGA CON</b></span>
                </td>
                <td style="width: 30%; text-align: right;">
                    <span class="voucher-label"><b>S/ ${parseFloat(
                      solicitud.pay_with
                    ).toFixed(2)}</b></span>
                </td>
              </tr>
              <tr>
                <td style="width: 70%; text-align: left;">
                    <span class="voucher-label"><b>VUELTO</b></span>
                </td>
                <td style="width: 30%; text-align: right;">
                    <span class="voucher-label"><b>S/ ${parseFloat(
                      solicitud.change
                    ).toFixed(2)}</b></span>
                </td>
              </tr>
            `;
      }
    }
    let documentoCustomer = `
    
    <div style="display:flex; width:15%">
      <div style="width:25%">
        <label>${solicitud.customer_type_document}: </label>
      </div>
      <div style="width:75%">
        <label style="font-weight:700;">${solicitud.customer_document}</label>
      </div>
    </div>
    `

    

    if(solicitud.customer_type_document == 'CARNET DE EXTRANJERÍA'){
      documentoCustomer = `
      <div style="display:flex; width:40%">
        <div style="width:47%">
          <label>CARNET DE EXTRANJERÍA: </label>
        </div>
        <div style="width:50%">
          <label style="font-weight:700;">${solicitud.customer_document}</label>
        </div>
      </div>`
    }else if(solicitud.customer_type_document == 'CÉDULA DIPLOMÁTICA DE IDENTIDAD'){
      documentoCustomer = `
      <div style="display:flex; width:40%">
        <div style="width:50%">
          <label>CÉDULA DIPLOMÁTICA DE IDENTIDAD: </label>
        </div>
        <div style="width:50%">
          <label style="font-weight:700;">${solicitud.customer_document}</label>
        </div>
      </div>`
    }else if(solicitud.customer_type_document == 'PASAPORTE'){
      documentoCustomer = `
      <div style="display:flex; width:15%">
        <div style="width:30%">
          <label>PASAPORTE: </label>
        </div>
        <div style="width:75%">
          <label style="font-weight:700;">${solicitud.customer_document}</label>
        </div>
      </div>`
    }

    const first_letter = solicitud.seller_first_name
      ? solicitud.seller_first_name[0]
      : "";
    const last_name_ = solicitud.seller_last_name
      ? solicitud.seller_last_name
      : "";
    const seller_name = first_letter + " " + last_name_;

    let usuario_name = solicitud.employee ? solicitud.employee.fullname : "";

    let content_detail = "";

    solicitud.detail.forEach((el) => {
      let quantity = el.quantity.toString().padStart(3, "0");
      let name = el.description;
      let product_code = el.code;
      const specialized_name = el.specialized_name
      let value_subtotal = parseFloat(el.subtotal);
      let value_discount = 0;
      if (el.discount_value) {
        value_discount = parseFloat(el.discount_value);
      }
      let subtotal_item =
        Math.round((value_subtotal - value_discount) * 100) / 100;
      let subtotal = `S/. ${parseFloat(subtotal_item).toFixed(2)}`.padStart(
        30,
        " "
      );

      // content_detail += `
      // <div style="display:flex; width:100%;">
      //   <label style="display:flex; width:15%;">${product_code}</label>
      //   <label style="display:flex; width:25%;">${specialized_name}</label>
      //   <label style="width:40%;">${name}</label>
      // </div>`;

      content_detail += `
      <div style="display:flex; width:100%;">
        <label style="width:60%;">${name}</label>
      </div>`;

    });

    const date_now = new Date().toLocaleString();

    const [date, hour] = solicitud.sales_date.split(" ");

    function calcularEdad(fecha) {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
      }

      return edad;
    }

    function formData(fecha){
      // const date = new Date(fecha);
      if(fecha == null) return "-"
      const [anio, mes, dia ] = fecha.split("-")
      // console.log("--->>", anio, mes, dia)
      const months = ["ENE", "FEB", "MAR","ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
      let formatted_date = dia + "-" + months[(Number(mes) - 1)] + "-" + anio
      return formatted_date;
    }

    let content = `        
          <style type="text/css" media="screen, print">
            @import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');
        
            @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
            
            .voucher-content{ 
                font-family: 'Open Sans', sans-serif;
                font-size: 10px;
                margin-top: 30px;
                margin-left: 25px;
                margin-right: 25px;
            }
          </style>
        
        <div class="voucher-content">
          <header>
            <div style="display:flex; justify-content: space-between;">
              <div style="display:flex; flex-direction: column;">
                ${logo_ticket}
              </div>
              <div style="display:flex; align-items:end; flex-direction: column; font-size: 11px;">
                <label>${solicitud.company_name} </label>
                <label>${solicitud.company_ruc}</label>
                <label style="width: 60%; text-align: right">${
                  solicitud.company_address
                }</label>
                <label style="margin-left:3px; font-weight:700;">${
                  solicitud.office_name
                }</label>
              </div>
            </div>

            <div style="display:flex; justify-content: space-between; font-size: 20px; font-weight: 700; margin-top:7px;">
              <label > ORDEN DE SERVICIO </label>
              <label>NUMERO: ${solicitud.order_code}</label>
            </div>

            <div style="display:flex; width:100%;">
                <div style="width:15.5%">
                  <label>NOMBRE DEL PACIENTE: </label>
                </div>
                <div style="width:84.5%">
                  <label style="font-weight:700;">${solicitud.customer_name}</label>
                </div>
            </div>

            <div style="display:flex; width:100%;">
            
              ${documentoCustomer}
              

              <div style="display:flex; width:15%">

                <div style="width:32%">
                  <label>SEXO: </label>
                </div>
                <div style="width:28%">
                  <label style="font-weight:700;">${solicitud.gender}</label>
                </div>

              </div>

              <div style="display:flex; width:20%">

                <div style="width:40%">
                  <label>Fecha Nac.: </label>
                </div>

                <div style="width:60%">
                  <label style="font-weight:700;">${formData(solicitud.customer_born_date)} </label>
                </div>

              </div> 

              <div style="display:flex; width:15%">

                <div style="width:32%">
                  <label>EDAD: </label>
                </div>

                <div style="width:60%">
                  <label style="font-weight:700;">${calcularEdad(
                    solicitud.customer_born_date
                  )} años</label>
                </div>

              </div>    
              
              

              <div style="display:flex; width:20%">
                <div style="width:22%">
                  <label>TELF: </label>
                </div>

                <div style="width:78%">
                  <label style="font-weight:700;"> ${
                    solicitud.customer_phone ? solicitud.customer_phone : ""
                  } </label>
                </div>
              </div>

            </div>

            <div style="display:flex; width:100%;">
                <div style="width:6.5%">
                  <label>MEDICO: </label>
                </div>
                <div style="width:93.5%">
                  <label style="font-weight:700;">${
                    solicitud.doctor_name ? solicitud.doctor_name : ""
                  }</label>
                </div>
            </div>

            <div style="display:flex; width:100%;">

              <div style="display:flex; width:50%">
                <div style="width:16%;">
                  <label>CONVENIO: </label>
                </div>
                <div style="width:84%">
                  <label style="font-weight:700;">${
                    solicitud.convenio_name ? solicitud.convenio_name : ""
                  }</label>
                </div>
              </div>

              <div style="display:flex; width:25%">
                <div style="width:14%">
                  <label>RUC: </label>
                </div>
                <div style="width:86%">
                  <label style="font-weight:700;">${
                    solicitud.convenio_ruc ? solicitud.convenio_ruc : ""
                  }</label>
                </div>
              </div>

              <div style="display:flex; width:25%">
                <div style="width:14%">
                  <label>TELF: </label>
                </div>
                <div style="width:86%">
                  <label style="font-weight:700;">${
                    solicitud.convenio_phone ? solicitud.convenio_phone : ""
                  }</label>
                </div>
              </div>

            </div>

            <div style="display:flex; width:100%;">

              <div style="display:flex; width:50%">
                <div style="width:20%;">
                  <label>CLIENTE: </label>
                </div>
                <div style="width:80%">
                  <label style="font-weight:700;">${
                    solicitud.empresa_name ? solicitud.empresa_name : ""
                  }</label>
                </div>
              </div>

              <div style="display:flex; width:25%">
                <div style="width:14%">
                  <label>RUC: </label>
                </div>
                <div style="width:86%">
                  <label style="font-weight:700;">${
                    solicitud.empresa_ruc ? solicitud.empresa_ruc : ""
                  }</label>
                </div>
              </div>

              <div style="display:flex; width:25%">
                <div style="width:14%">
                  <label>TELF: </label>
                </div>
                <div style="width:86%">
                  <label style="font-weight:700;">${
                    solicitud.empresa_phone ? solicitud.empresa_phone : ""
                  }</label>
                </div>
              </div>

            </div>
            
            <div style="display:flex; width:100%; margin-top: 8px; justify-content:space-between;">
              
              <div style="display:flex; flex-direction: column;">
                <div style="display:flex; ">
                  <div style="display:flex; ">
                    <label>CORTESIA: </label>
                    <label style="margin-left:11px;font-weight:700;">${
                      solicitud.cortesia ? "SI" : "NO"
                    }<label>
                  </div>
                  <div style="display:flex; margin-left:20px;">
                    <label >AUTORIZADO POR: </label>
                    <label style="margin-left:11px; font-weight:700;"> ${
                      solicitud.employees_cortesia_fullname ? solicitud.employees_cortesia_fullname : ""
                    }</label>
                  </div>
                </div>
                <div style="display:flex; ">
                  <label>FECHA DE REGISTRO:</label>
                  <label style="margin-left:11px;font-weight:700;">${date}</label>
                </div>
                
                <div style="display:flex;">
                    <label>HORA TOMA DE MUESTRA: </label>
                </div>
                <div style="display:flex;">
                    <label>LUGAR TOMA DE MUESTRA:  <b>${solicitud.lugar_atencion ? solicitud.office_name  : customer_address }</b></label>
                </div>
              </div>

              <div style="display:flex;">
                <div style="display:flex; flex-direction: column;">
                  <div style="display:flex;">
                    <label>PRIORIDAD: </label>
                    <label style="margin-left:11px;font-weight:700;"> ${
                      solicitud.type_prioridad ? solicitud.type_prioridad : ""
                    } </label>
                  </div>
                  <div style="display:flex;">
                    <label>USUARIO REGISTRA: </label>
                    <label style="margin-left:11px; font-weight:700;"> ${seller_name}</label>
                  </div>
                  <div style="display:flex;">
                    <label>SEDE DE ATENCION:</label>
                    <label style="margin-left:11px; font-weight:700;">${
                      solicitud.office_atencion_name ? solicitud.office_atencion_name : ""
                    }</label>
                  </div>
                </div>
              </div>
    
            </div>

          </header>

          <div style="display:flex; flex-direction: column; width:100%; margin: 14px 0;">
            <div style="display:flex; width:100%; font-size:14px; font-weight:700; padding: 3px 0;">
              <label style="width:60%;">ANALISIS</label>
            </div>
            <div style="display:flex; flex-direction: column; width:100%; font-size:13px;">
              ${content_detail}
            </div>
          </div>

          

          <footer style="position: absolute; bottom: 0; left: 0; width:100%; margin-left:25px; margin-right:25px; margin-bottom: 30px;">
            <div style="display:flex; width:100%; padding: 0 10px; align-items:center;">
              <div style="width: 13%;">
                <label>OBSERVACIONES 1:</label>
              </div>
              <div style="display:flex; width: 78.7%; border: 1px solid #000; border-radius: 10px; height: 60px;">
                ${solicitud.observacion ? solicitud.observacion : ""}
              </div>
            </div>

            <div style="display:flex; width:100%; padding: 0 10px; align-items:center; margin-top:10px;">
              <div style="width: 13%;">
                <label>OBSERVACIONES 2:</label>
              </div>
              <div style="display:flex; width: 78.7%; border: 1px solid #000; border-radius: 10px; height: 120px;">
              </div>
            </div>

            <div style="display:flex; width:100%; justify-content: space-between; margin-top:30px; margin-left:10px; padding-bottom: 6px;">
              
              <div style="display:flex; flex-direction: column;">
                <div style="display:flex; margin-bottom: 6px;">
                  <label style="font-size:13.5px; font-weight:700;">ESTADO DE ATENCION</label>
                </div>
                <div style="display:flex; align-items:center; padding: 2px 0;">
                  <label>TOMA DE MUESTRA</label>
                  <div style="width:10px; height:10px; border: 1px solid #000; margin-left:7px;"></div>
                </div>
                <div style="display:flex; align-items:center; padding: 2px 0;">
                  <label>PROCESADO</label>
                  <div style="width:10px; height:10px; border: 1px solid #000; margin-left:7px;"></div>
                </div>
                <div style="display:flex; align-items:center; padding: 2px 0;">
                  <label>INFORMADO</label>
                  <div style="width:10px; height:10px; border: 1px solid #000; margin-left:7px;"></div>
                </div>
                <div style="display:flex; align-items:center; padding: 2px 0;">
                  <label>ENVIADO LOS RESULTADOS</label>
                  <div style="width:10px; height:10px; border: 1px solid #000; margin-left:7px;"></div>
                </div>
              </div>

              <div style="display:flex; flex-direction: column;">
                <div style="display:flex; margin-bottom: 6px;">
                  <label style="font-size:13.5px; font-weight:700;">RESULTADOS</label>
                </div>
                <div style="display:flex; align-items:center; padding: 2px 0;">
                  <label>WSA</label>
                  <div style="width:10px; height:10px; border: 1px solid #000; margin-left:7px;"></div>
                </div>
                <div style="display:flex; align-items:center; padding: 2px 0;">
                  <label>CORREO</label>
                  <div style="width:10px; height:10px; border: 1px solid #000; margin-left:7px;"></div>
                </div>
                <div style="display:flex; align-items:center; padding: 2px 0;">
                  <label>FISICO</label>
                  <div style="width:10px; height:10px; border: 1px solid #000; margin-left:7px;"></div>
                </div>
              </div>

              <div style="display:flex; flex-direction: column; width:30%; margin-top:45px; padding-right: 17px;">
                <div style="display: center; width:80%; border-top: 1px solid #000;"></div>
                <div style="display:flex; margin-top:4px;">
                  <label>AUTORIZA: </label>
                  <div style="margin-left:5px; width:30%; border-bottom: 1px solid #000;"></div>
                </div>
                <div style="display:flex; margin-top:4px;">
                  <label>DNI: </label>
                  <div style="margin-left:5px; width:30%; border-bottom: 1px solid #000;"></div>
                </div>
              </div>

            </div>

            <div style="display:flex; width:100%; padding: 0 10px; align-items:center; padding-top:15px;">
              <div style="width: 40%;">
                <label>USUARIO IMPRIME</label>
                <label style="margin-left:5px;"> ${usuario_name} </label>
              </div>
              <div style="width: 60%;">
                <label>FECHA</label>
                <label style="margin-left:5px;"> ${date_now} </label>
              </div>
            </div>

          </footer>

        </div>`;

    return content;
  },
};

{
  // modificacion de  CODIGO AREA DE EXAMEN
  // <div style="display:flex; flex-direction: column; width:100%; margin: 14px 0;">
  //   <div style="display:flex; width:100%; font-size:14px; font-weight:700; padding: 3px 0;">
  //     <label style="width:15%;">CODIGO</label>
  //     <label style="width:25%;">AREA DE EXAMEN</label>
  //     <label style="width:40%;">ANALISIS</label>
  //   </div>
  //   <div style="display:flex; flex-direction: column; width:100%; font-size:13px;">
  //     ${content_detail}
  //   </div>
  // </div>
}



{
  /* <label style="margin-left:5px; margin-top:10px; width:160px; border-top: 1px solid #000;"></label> */
}

{
  /* <div style="display:flex; width:100%;">
            <div style="width:20%">
              <label>PROCEDENCIA DEL PACIENTE: </label>
            </div>
            <div style="width:80%">
              <label></label>
            </div>
          </div>

          <div style="display:flex; width:100%;">
            <div style="width:20%">
              <label>MEDICO QUE AUTORIZA: Dr(a): </label>
            </div>
            <div style="width:80%">
              <label>SOLICITUD DEL, PACIENTE</label>
            </div>
          </div>

          <div style="display:flex; width:100%;">
            <div style="width:30%">
              <label>MEDICO QUE DEBE INFORMAR: Dr(a): </label>
            </div>
            <div style="width:70%">
              <label></label>
            </div>
          </div>

          <div style="display:flex; width:100%; font-size:17px; font-weight:800; margin-top:3px;">
            <div style="width:10%">
              <label>COSTO: </label>
            </div>
            <div style="width:90%">
              <label>S/. 0.00</label>
            </div>
          </div> */
}
